import * as React from 'react';
import { Paper } from 'components/paper';
import { Button } from '@material-ui/core';
import { GSMonthlyVacationExportDialog } from './GSMonthlyVacationExportDialog';

export class MonthlyVacationExportPaper extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = new State();

        this.handleExportButtonClicked = this.handleExportButtonClicked.bind(this);
        this.handleDialogCancelClicked = this.handleDialogCancelClicked.bind(this);
    }

    private handleExportButtonClicked() {
        this.setState({isDialogVisible: true});
    }

    private handleDialogCancelClicked() {
        this.setState({isDialogVisible: false});
    }

    public render() {
        return (
            <>
                <Paper title="Monthly vacation export" desc="Exports the vacations and other leave offs of all the users in a given month.">
                    <Button variant="contained" onClick={this.handleExportButtonClicked}>Google Spreadheet</Button>
                </Paper>
                {this.state.isDialogVisible && (
                    <GSMonthlyVacationExportDialog onCancelClicked={this.handleDialogCancelClicked} />
                )}
                
            </>
        );
    }

}

export class Props {

}

class State {

    public isDialogVisible: boolean;

}